import type { FdsAction } from "../../api/fds";

export const REASON_LABELS: Record<string, string> = {
  NoBaseline: "Belum ada acuan baseline",
  ZeroBaseline: "Acuan baseline nol",
  TotalDeviation: "Selisih total pokok melewati ambang",
  RosterMismatch: "Roster tidak sesuai acuan",
  OutsideCycleWindow: "Di luar jendela siklus",
  DuplicateBatch: "Batch duplikat",
  NoKycApproval: "Belum ada persetujuan KYC",
  BankDetailsChanged: "Data rekening berubah",
  NoApprovedPrincipal: "Belum ada pokok yang disetujui",
  PrincipalDeviation: "Selisih pokok penerima melewati ambang",
  ListCheckPotentialMatch: "Potensi kecocokan daftar resmi",
};

export function reasonLabel(reason: string): string {
  return REASON_LABELS[reason] ?? reason;
}

export const SCOPE_LABELS: Record<string, string> = {
  WholeBatch: "Seluruh batch",
  Recipient: "Penerima saja",
};

export function scopeLabel(scope: string): string {
  return SCOPE_LABELS[scope] ?? scope;
}

export const ALLOWED_ACTIONS: Record<string, FdsAction[]> = {
  Open: ["acknowledge", "escalate", "release", "reject", "block"],
  Acknowledged: ["escalate", "release", "reject", "block"],
  Escalated: ["release", "reject", "block"],
  Blocked: ["lift"],
  Released: [],
  Rejected: [],
};

export function allowedActions(stage: string): FdsAction[] {
  return ALLOWED_ACTIONS[stage] ?? [];
}

export const ACTION_LABELS: Record<FdsAction, string> = {
  acknowledge: "Akui kasus",
  escalate: "Eskalasi",
  release: "Lepas",
  reject: "Tolak",
  block: "Blokir",
  lift: "Cabut blokir",
};

export const ACTION_VARIANT: Record<
  FdsAction,
  "secondary" | "warning" | "success" | "danger"
> = {
  acknowledge: "secondary",
  escalate: "warning",
  release: "success",
  reject: "danger",
  block: "danger",
  lift: "success",
};

export function needsAuthorityRef(action: FdsAction): boolean {
  return action === "block" || action === "lift";
}

export function deviationLabel(
  observed: string | null,
  approved: string | null,
): string | null {
  const base = Number(approved);
  if (observed === null || approved === null || !(base > 0)) return null;
  const pct = ((Number(observed) - base) / base) * 100;
  const sign = pct > 0 ? "+" : "";
  return `${sign}${pct.toLocaleString("id-ID", { maximumFractionDigits: 1 })}%`;
}
